export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pt": {
        "new-project": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Novo projeto"])},
        "active-projects": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Projetos ativos"])},
        "disabled-projects": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Projetos desativados"])},
        "project-to-manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Qual projeto você quer gerenciar hoje?"])},
        "hero-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Você só precisa decidir por onde vamos começar"])},
        "hero-subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alta performance, de um jeito simples e ágil."])}
      }
    }
  })
}